import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Process } from "../../EventAlert/types";
import OrderInlineDetail from "../../Order/InlineDetail";
import IOInlineDetail from "../../IO/InlineItem";
import { detailsFields, Number } from "../Order/Precheck/Details";
import style from "./style.module.scss";
import CircularProgress from "../../CircularProgress/CircularProgress";

const trimAll = (text) => text.replace(/"\s+|\s+"/g, '"');

export const SubTitle = ({ process, props }) => {
  switch (process) {
    case Process.Order:
    case Process.BulkOrder:
    case Process.BasketOrder:
      return <OrderInlineDetail order={JSON.parse(trimAll(props["Order"]))} hideAvg />;

    case Process.Deposit:
    case Process.Withdraw:
    case Process.Transfer:
      // check if IO no exists
      const io = JSON.parse(trimAll(props["IO"]));
      if (io.Id == 0) {
        return null;
      }

      return <IOInlineDetail io={io} />;

    default:
      return null;
  }
};

export const ProcessContext = ({ process, props }) => {
  switch (process) {
    case Process.Order:
    case Process.BulkOrder:
    case Process.BasketOrder:
      // remove unnecesary info, info can be handled by button in dialog
      // const order = JSON.parse(trimAll(props['Order']));
      // const account = JSON.parse(trimAll(props['Account']));
      // return (
      //   <div>
      //     <OrderDetail
      //       form={order.AssetClassForm}
      //       result={order.precheck}
      //       balance={account.items}
      //     />
      //   </div>
      // );
      return null;

    case Process.Deposit:
    case Process.Withdraw:
    case Process.Transfer:
      return null;

    default:
      return null;
  }
};

export const LoadingMessage = ({ text }) => (
  <div className={style.loadingMessage}>
    <CircularProgress sm style={{ margin: "0px" }} />
    <span>{text}</span>
  </div>
);

const OrderDetail = ({ form, result, balance }) => {
  const rows = detailsFields(result, form);
  return (
    <div className={style.orderDetail}>
      <Container>
        <Row>
          <Col lg={5}>
            <div className={style.totals}>
              <table>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={`pcheck-${index}`}>
                      <td>{row.label}</td>
                      <td>
                        <Number value={row.value} dataTypeDecimalName="currency" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
          <Col lg={7}>
            <div className={style.balance}>
              {balance.map(
                (item, index) =>
                  item.key !== "" && (
                    <div key={`bitem-${index}`} className={style.item}>
                      <span>{item.key}</span>
                      <Number value={item.value} dataTypeDecimalName="currency" />
                    </div>
                  )
              )}
            </div>
            <div className={style.totalPortfolio}>
              <span>Total Portofolio (USD):</span>
              <Number value={5000000} dataTypeDecimalName="currency" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
